import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_EMPRESA_INIT,
  LIST_EMPRESA_INIT,
  DELETE_EMPRESA_INIT,
  MODIFY_EMPRESA_INIT,
  ATRIBUIR_PAINEIS_EMPRESA_INIT
} from '../actionTypes';
import {
  createEmpresaSuccess,
  listEmpresaSuccess,
  deleteEmpresaSuccess,
  modifyEmpresaSuccess,
  empresaErrorMsg,
  atribuiPainelEmpresaSuccess
} from './actions';
import { IEmpresa } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';
import { IEmpresaStatusEmpresa } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { atribuiPaineisEmpresa, atualizarEmpresa, criarEmpresa, deletarEmpresa, listarEmpresas } from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';

interface FetchListaEmpresasResult {
  isError: boolean;
  empresas: IEmpresa[] | null;
  statusEmpresas: IEmpresaStatusEmpresa[] | null;
  errorMessage: string | null;
}

/* ------------------Lista empresas---------------- */
export const fetchListarEmpresas = async (): Promise<FetchListaEmpresasResult> => {
  try {
    const { status, dados, mensagem } = await listarEmpresas();

    if (status && Array.isArray(dados?.allEmps)) {
      return {
        isError: false,
        empresas: dados.allEmps,
        statusEmpresas: dados.allStatusEmps,
        errorMessage: mensagem,
      };
    }

    return {
      isError: true,
      empresas: [],
      statusEmpresas: null,
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarEmpresas({ payload }: { payload: any, type: any }) {
  try {
    const { isError, empresas, statusEmpresas, errorMessage } = yield call(fetchListarEmpresas);
    if (!isError) {
      yield put(listEmpresaSuccess(empresas, statusEmpresas));
    } else {
      yield put(empresaErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    yield put(empresaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarEmpresas() {
  yield takeEvery(LIST_EMPRESA_INIT, parseListarEmpresas);
}

/* ------------------Criar empresa ---------------- */
export const fetchCriarEmpresa = async (empresa: any) => {
  try {

    const { status, dados, mensagem } = await criarEmpresa(empresa);

    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarEmpresa({ payload }: { payload: any, type: any }) {
  const { empresa } = payload;
  try {
    const { isCreated, msg, data } = yield call(fetchCriarEmpresa, empresa);

    if (isCreated) {
      yield put(createEmpresaSuccess({ empresa: data, msg: msg, isCreated }));
    } else {
      yield put(empresaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      empresaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarEmpresa() {
  yield takeEvery(CREATE_EMPRESA_INIT, parseCriarEmpresa);
}


/* ------------------Atualiza empresa ---------------- */
export const fetchAtualizarEmpresa = async (id: string, empresa: any) => {
  try {
    const { status, dados, mensagem } = await atualizarEmpresa(id, empresa);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarEmpresa({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isUpdated, msg, data } = yield call(fetchAtualizarEmpresa, id, payload);

    if (isUpdated) {
      yield put(modifyEmpresaSuccess({ msg, isUpdated, empresa: data }));
    } else {
      yield put(empresaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(

      empresaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarEmpresa() {
  yield takeEvery(MODIFY_EMPRESA_INIT, parseAtualizarEmpresa);
}

/* ------------------Deletar empresa ---------------- */
export const fetchDeletarEmpresa = async (empId: string) => {
  try {
    const { status, mensagem } = await deletarEmpresa(empId);
    if (status) {
      return { isDeleted: true, msg: mensagem };
    } else {
      return {
        isDeleted: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarEmpresa({ payload }: { payload: any; type: any }) {
  const { empId } = payload;
  try {
    const { isDeleted, msg } = yield call(fetchDeletarEmpresa, empId);

    if (isDeleted) {
      yield put(deleteEmpresaSuccess({ msg, isDeleted, empId }));
    } else {
      yield put(empresaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      empresaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarEmpresa() {
  yield takeEvery(DELETE_EMPRESA_INIT, parseDeletarEmpresa);
}


// --------------------- Atribuir paineis a um Empresa --------------------------------------------------
const fetchAtribuiPaineisEmpresa = async (empId: string, paineis: string[]) => {
  try {
    const resposta = await atribuiPaineisEmpresa(
      empId,
      paineis
    );
    if (resposta.status) {
      return { isAssign: true, msg: resposta.mensagem };
    } else {
      return {
        isAssign: false,
        msg: resposta.mensagem
      };
    }
  }
  catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtribuiPaineisEmpresa({ payload }: { payload: any, type: any }) {
  const { empId, paineis } = payload;
  try {
    const { isAssign, msg } = yield call(fetchAtribuiPaineisEmpresa, empId, paineis);
    if (isAssign) {
      yield put(atribuiPainelEmpresaSuccess({ msg, isAssign, paineis }));
    } else {
      yield put(empresaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(empresaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchAtribuPaineisEmpresa() {
  yield takeEvery(ATRIBUIR_PAINEIS_EMPRESA_INIT, parseAtribuiPaineisEmpresa);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarEmpresas),
    fork(watchCriarEmpresa),
    fork(watchAtualizarEmpresa),
    fork(watchDeletarEmpresa),
    fork(watchAtribuPaineisEmpresa),
  ]);
}
